import { render, staticRenderFns } from "./Ingbiro.vue?vue&type=template&id=b8087308&scoped=true&"
import script from "./Ingbiro.vue?vue&type=script&lang=js&"
export * from "./Ingbiro.vue?vue&type=script&lang=js&"
import style1 from "./Ingbiro.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8087308",
  null
  
)

export default component.exports